import { Container, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import CollapsibleHelpSection from '../components/common/CollapsibleHelpSection';
import PageMeta from '../components/common/PageMeta';
import LegalPageStructuredData from '../components/common/LegalPageStructuredData';
import { isBillingEnabled } from '../utils/config';

export default function Terms() {
  const { t } = useTranslation();

  return (
    <>
      <PageMeta titleKey="terms.title" descriptionKey="terms.meta_description" path="terms" llmsDescribedBy />
      <LegalPageStructuredData page="terms" />
      <Container className="mt-4">
      <h1 className="mb-4">
        <i className="fas fa-file-contract text-primary me-2"></i>
        {t('terms.title')}
      </h1>

      <CollapsibleHelpSection
        titleKey="terms.how_to_use_title"
        descriptionKey="terms.how_to_use_desc"
        storageKey="terms_page"
        defaultExpanded={false}
      />

      <Card>
        <Card.Body>
          <section className="mb-4">
            <h3>{t('terms.article1_title')}</h3>
            <p>{t('terms.article1_content')}</p>
            <ul>
              {t('terms.article1_item1') && <li>{t('terms.article1_item1')}</li>}
              {t('terms.article1_item2') && <li>{t('terms.article1_item2')}</li>}
              {t('terms.article1_item3') && <li>{t('terms.article1_item3')}</li>}
              {t('terms.article1_item4') && <li>{t('terms.article1_item4')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article2_title')}</h3>
            <p>{t('terms.article2_content')}</p>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article3_title')}</h3>
            <p>{t('terms.article3_content')}</p>
            <ul>
              <li>{t('terms.article3_item1')}</li>
              <li>{t('terms.article3_item2')}</li>
              <li>{t('terms.article3_item3')}</li>
              <li>{t('terms.article3_item4')}</li>
              <li>{t('terms.article3_item5')}</li>
              {t('terms.article3_item6') && <li>{t('terms.article3_item6')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article4_title')}</h3>
            <p>{t('terms.article4_content')}</p>
            <ul>
              <li>{t('terms.article4_item1')}</li>
              <li>{t('terms.article4_item2')}</li>
              {t('terms.article4_item3') && <li>{t('terms.article4_item3')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article5_title')}</h3>
            <p>
              {isBillingEnabled()
                ? t('terms.article5_content')
                : t('terms.article5_content_free', {
                    defaultValue: '現在は開発期間中に付き無料でご利用いただけます。',
                  })}
            </p>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article6_title')}</h3>
            <p>{t('terms.article6_content')}</p>
            <ul>
              {t('terms.article6_item1') && <li>{t('terms.article6_item1')}</li>}
              {t('terms.article6_item2') && <li>{t('terms.article6_item2')}</li>}
              {t('terms.article6_item3') && <li>{t('terms.article6_item3')}</li>}
              {t('terms.article6_item4') && <li>{t('terms.article6_item4')}</li>}
              {t('terms.article6_item5') && <li>{t('terms.article6_item5')}</li>}
              {t('terms.article6_item6') && <li>{t('terms.article6_item6')}</li>}
              {t('terms.article6_item7') && <li>{t('terms.article6_item7')}</li>}
              {t('terms.article6_item8') && <li>{t('terms.article6_item8')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article7_title')}</h3>
            <p>{t('terms.article7_content')}</p>
            <ul>
              {t('terms.article7_item1') && <li>{t('terms.article7_item1')}</li>}
              {t('terms.article7_item2') && <li>{t('terms.article7_item2')}</li>}
              {t('terms.article7_item3') && <li>{t('terms.article7_item3')}</li>}
              {t('terms.article7_item4') && <li>{t('terms.article7_item4')}</li>}
              {t('terms.article7_item5') && <li>{t('terms.article7_item5')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article8_title')}</h3>
            <p>{t('terms.article8_content')}</p>
            <ul>
              {t('terms.article8_item1') && <li>{t('terms.article8_item1')}</li>}
              {t('terms.article8_item2') && <li>{t('terms.article8_item2')}</li>}
              {t('terms.article8_item3') && <li>{t('terms.article8_item3')}</li>}
              {t('terms.article8_item4') && <li>{t('terms.article8_item4')}</li>}
              {t('terms.article8_item5') && (
                <li>
                  {isBillingEnabled()
                    ? t('terms.article8_item5')
                    : t('terms.article8_item5_free', {
                        defaultValue:
                          '運営者に故意または重大な過失がある場合、運営者の損害賠償責任については、法律の定めるところによります。',
                      })}
                </li>
              )}
              {t('terms.article8_item6') && <li>{t('terms.article8_item6')}</li>}
              {t('terms.article8_item7') && <li>{t('terms.article8_item7')}</li>}
              {t('terms.article8_item8') && <li>{t('terms.article8_item8')}</li>}
              {t('terms.article8_item9') && <li>{t('terms.article8_item9')}</li>}
              {t('terms.article8_item10') && <li>{t('terms.article8_item10')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article9_title')}</h3>
            <p>{t('terms.article9_content')}</p>
            <ul>
              {t('terms.article9_item1') && <li>{t('terms.article9_item1')}</li>}
              {t('terms.article9_item2') && <li>{t('terms.article9_item2')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article10_title')}</h3>
            <p>{t('terms.article10_content')}</p>
            <ul>
              {t('terms.article10_item1') && <li>{t('terms.article10_item1')}</li>}
              {t('terms.article10_item2') && <li>{t('terms.article10_item2')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article11_title')}</h3>
            <p>{t('terms.article11_content')}</p>
            <ul>
              {t('terms.article11_item1') && <li>{t('terms.article11_item1')}</li>}
              {t('terms.article11_item2') && <li>{t('terms.article11_item2')}</li>}
              {t('terms.article11_item3') && <li>{t('terms.article11_item3')}</li>}
              {t('terms.article11_item4') && <li>{t('terms.article11_item4')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article12_title')}</h3>
            <p>{t('terms.article12_content')}</p>
            <ul>
              {t('terms.article12_item1') && <li>{t('terms.article12_item1')}</li>}
              {t('terms.article12_item2') && <li>{t('terms.article12_item2')}</li>}
            </ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article13_title')}</h3>
            <p>{t('terms.article13_content')}</p>
            <ul>{t('terms.article13_item1') && <li>{t('terms.article13_item1')}</li>}</ul>
          </section>

          <section className="mb-4">
            <h3>{t('terms.article14_title')}</h3>
            <p>{t('terms.article14_content')}</p>
            <ul>
              {t('terms.article14_item1') && <li>{t('terms.article14_item1')}</li>}
              {t('terms.article14_item2') && <li>{t('terms.article14_item2')}</li>}
              {t('terms.article14_item3') && <li>{t('terms.article14_item3')}</li>}
              {t('terms.article14_item4') && <li>{t('terms.article14_item4')}</li>}
              {t('terms.article14_item5') && <li>{t('terms.article14_item5')}</li>}
              {t('terms.article14_item6') && <li>{t('terms.article14_item6')}</li>}
            </ul>
          </section>

          <div className="text-muted mt-4">
            <p>
              <strong>{t('terms.end')}</strong>
            </p>
          </div>
        </Card.Body>
      </Card>
    </Container>
    </>
  );
}
